export type CheckboxItemPickerProps = {
  values: Array<string>;
  selectedValues: Array<string>;
  onSelect: (item: number) => void;
  width?: number;
};

export { default as CheckboxItemPicker } from './CheckboxItemPicker';
